export async function getContactContentChat() {
  try {
    const resp = await fetch(`https://gateway.asdi.foundation/utils/asdi-social-network?isGetAll=true`, {
      method: 'GET',
    })

    if (resp.status === 200) {
      const data = await resp.json()
      return data?.data
    }
  } catch (error) {
    console.error('~setGetSetting', error)
  }

  return null
}
